import { SpringContainer } from "./views";
import { withAnimation, withDefaultRefs, withDragScroll } from "./enhancers";

/** Highly pimped DraggableScrollContainer */
export var AnimatedScrollContainer = withDefaultRefs(withAnimation(withDragScroll(SpringContainer)));
export default withDefaultRefs(withDragScroll(SpringContainer));